import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import MapImportFormTable
    from "v4/pages/admin/Import/components/ImportSteps/components/MapImport/components/MapImportFormTable/MapImportFormTable";
import {SearchProvider} from "v4/contexts/SearchContext/SearchContext";
import PolButton from "v4/components/ui/PolButton/PolButton";
import {routesBase} from "v4/data/appRoutes";
import {PolIcon} from "components/PolIcon/policon";
import {useImportContext} from "v4/pages/admin/Import/contexts/ImportContext";

export default function MapImport() {
    const {t} = usePolTranslation();
    const {selectedEntityType} = useImportContext();

    return (
        <AdminCard title={`${selectedEntityType ? `${t(selectedEntityType)} -` : ''} ${t('data_matching')}`}
                   beforeTitleRender={() => (
                       <PolButton to={routesBase.adminDataImport}
                                  className="mr-2 btn-primary">
                           <PolIcon icon="arrow-left"/>
                           {t('cancel')}
                       </PolButton>
                   )}>
            <SearchProvider>
                <MapImportFormTable/>
            </SearchProvider>
        </AdminCard>
    )
}
